import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-booking-visibility-modal',
  templateUrl: './booking-visibility-modal.component.html',
  styleUrls: ['./booking-visibility-modal.component.scss'],
})
export class BookingVisibilityModalComponent {
  constructor(private modalController: ModalController) {}

  applyPermanently(): void {
    this.modalController.dismiss('permanent');
  }

  applyTemporarily(): void {
    this.modalController.dismiss('temporary');
  }
}
